import React, { useEffect } from 'react'
import { useState } from 'react'
import {ReactComponent as HeartIcon} from '../../../../images/icons/like.svg'
import {ReactComponent as HeartIconFill} from '../../../../images/icons/Liked.svg'
import {ReactComponent as BookmarksIcon} from '../../../../images/icons/Bookmark.svg'
import {ReactComponent as BookmarksIconFill} from '../../../../images/icons/Bookmark_Active.svg'
import {ReactComponent as MessageIcon} from '../../../../images/icons/Message.svg'
import {ReactComponent as MessageIconFill} from '../../../../images/icons/Message_Active.svg'
import { ReactComponent as ChatIcon} from '../../../../images/icons/Chat.svg'
import { ReactComponent as MessageChatIcon} from '../../../../images/icons/MessageChat.svg'
import { ReactComponent as ShareIcon} from '../../../../images/icons/share.svg'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { Link } from 'react-router-dom'
import CommentBox from '../../../others/comments'
import ApiUrl from '../../../../configTools/apiUrl'
import Button from '../../../forms/blackfillButton'

import SharePopup from '../../others/sharePopup'

const FeedItem = ({Item,refreshFeeds}) => {
  const [User,setUser] = useState(JSON.parse(localStorage.getItem("user-info")));
  const [Comments, setComments] = useState([]);
  const [CommentsActive, setCommentsActive] = useState(0);

  const [shareActive, setShareActive] = useState(0);
  const [sharepath, setSharePath] = useState('');
  const openShare = (e)=>{
    setSharePath(e);
    setShareActive(1);
  }
  
  useEffect(()=>{
    fetch(ApiUrl.API_URL_Comments+"/"+Item.id)
    .then(res=>res.json())
    .then(data =>{
      setComments(data);
    })
  },[])
  const toggleComments = ()=>{
    if(CommentsActive === 0){
      setCommentsActive(1);
    }
    else{
      setCommentsActive(0);
    }
  }
  const change_bookmark = ()=>{
    fetch(ApiUrl.API_URL_Bookmark, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify({
          productid : Item.id
        })
      })
      .then(res=>res.json())
      .then(data =>{
        refreshFeeds();
    });
  }
  const change_like = ()=>{
      fetch(ApiUrl.API_URL_Like, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          },
          body: JSON.stringify({
            listingid : Item.id
          })
        })
        .then(res=>res.json())
        .then(data =>{
          refreshFeeds();
      });
  }
  return (
    <div className='public_home_feeds_item_container'>
      <div className='public_home_feeds_item_title_container'>
        <div className='public_home_feeds_item_title_image'>
          <label style={{cursor:"pointer"}}>
              <div style={{
                  width: "100%",
                  paddingTop: "80%",
                  borderRadius: "10px",
                  position: "relative",
                  backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+Item.profile})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center'
                  
              }}>
              </div>
          </label>
        </div>
        <div className='public_home_feeds_item_title_name'>
            <Link to={"/user/"+Item.username}><h5>{Item.user}</h5></Link>
        </div>
      </div>
      <div className='public_home_feeds_item_image_container'>
            <Swiper
            // install Swiper modules
            modules={[Navigation]}
            slidesPerView={1}
            navigation={true}
            scrollbar={{ draggable: true }}
            >
            {
                Item.image.map((item,index)=>{
                    return(
                    <SwiperSlide key={index}>
                        <div className='public_home_hero_container'>
                        <img src={ApiUrl.API_URL_Image_Collection+item} alt='feed'/>
                        </div>
                    </SwiperSlide>
                    )
                })
            }
            </Swiper>
      </div>
      <div className='public_home_feeds_item_icon_container'>
        <div className='public_home_feeds_item_icon_left'>
            <div className='public_home_feeds_item_icon_item'>
                {Item.thislike === false &&
                  <HeartIcon  width="20px" height="40px" onClick={change_like} />
                }
                {Item.thislike === true &&
                  <HeartIconFill  width="20px" height="40px" onClick={change_like} />
                }
            </div>
            <div className='public_home_feeds_item_icon_item'>
              {CommentsActive === 1 &&
                <MessageIconFill  width="20px" height="40px" onClick={toggleComments}/>
              }
              {CommentsActive === 0 &&
                <MessageIcon  width="20px" height="40px" onClick={toggleComments}/>
              }
            </div>
            <div className='public_home_feeds_item_icon_item'>
              <MessageChatIcon width="20px" height="40px" />
            </div>
            <div className='public_home_feeds_item_icon_item'>
              <ShareIcon width="20px" height="40px" onClick={()=>{openShare("product/"+Item.slug)}}/>
            </div>
        </div>
        <div className='public_home_feeds_item_icon_right'>
            <Link style={{padding:"0px 10px"}} to={'/product/'+Item.slug}><Button Value={'Buy now'} /></Link>
            <div className='public_home_feeds_item_icon_item'>
              {Item.thiebookmark === false &&
                <BookmarksIcon  width="20px" height="40px" onClick={change_bookmark}/>
              }
              {Item.thiebookmark === true &&
                <BookmarksIconFill  width="20px" height="40px" onClick={change_bookmark}/>
              }
            </div>
        </div>
      </div>
      <div className='public_home_feeds_item_details_container'>
        <p><b>{Item.title}</b></p>
      </div>
      <div className='public_home_feeds_item_comment_container'>
        <>
        {CommentsActive === 1 &&
          <div className='comment_post_container'>
            <CommentBox productID={Item.id} comments={Comments} setComments={setComments} />
          </div>
        }
        </>
      </div>
      <SharePopup Active={shareActive} SetActive={setShareActive} Path={sharepath}/>
    </div>
  )
}

export default FeedItem
